import { render } from "./HasSubmissionModal.vue?vue&type=template&id=77b21a3e&scoped=true"
import script from "./HasSubmissionModal.vue?vue&type=script&lang=js"
export * from "./HasSubmissionModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/commonModal.scss?vue&type=style&index=0&id=77b21a3e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b21a3e"]])

export default __exports__